import { i18n } from '@/plugins/i18n'

export const readableTopic = {
  get PRICING () { return i18n.t('enums.returnCallTopic.PRICING') },
  get INHERITANCE () { return i18n.t('enums.returnCallTopic.INHERITANCE') },
  get DIVORCE () { return i18n.t('enums.returnCallTopic.DIVORCE') },
  get SALE () { return i18n.t('enums.returnCallTopic.SALE') },
  get RENT () { return i18n.t('enums.returnCallTopic.RENT') },
  get BUYING_INTEREST () { return i18n.t('enums.returnCallTopic.BUYING_INTEREST') },
  get CREDIT () { return i18n.t('enums.returnCallTopic.CREDIT') },
  get REPLACEMENT () { return i18n.t('enums.returnCallTopic.REPLACEMENT') },
  get LIFE_ANNUITY () { return i18n.t('enums.returnCallTopic.LIFE_ANNUITY') },
  get PARTIAL_SALE () { return i18n.t('enums.returnCallTopic.PARTIAL_SALE') },
  get PROPERTY_TAX () { return i18n.t('enums.returnCallTopic.PROPERTY_TAX') },
  get OTHER () { return i18n.t('enums.returnCallTopic.OTHER') }
}

export const readableCallbackTime = {
  get FORENOON () { return i18n.t('enums.callbackTime.FORENOON') },
  get NOON () { return i18n.t('enums.callbackTime.NOON') },
  get AFTERNOON () { return i18n.t('enums.callbackTime.AFTERNOON') },
  get EVENING () { return i18n.t('enums.callbackTime.EVENING') }
}
